import { render, staticRenderFns } from "./GetHelp.vue?vue&type=template&id=024da6b7&scoped=true"
import script from "./GetHelp.vue?vue&type=script&lang=js"
export * from "./GetHelp.vue?vue&type=script&lang=js"
import style0 from "./GetHelp.vue?vue&type=style&index=0&id=024da6b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024da6b7",
  null
  
)

export default component.exports